export default "__VITE_ASSET__BXHWsI2e__"